import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import PropTypes from "prop-types";
import React from "react";
import { useDarkMode } from "../assets/DarkModeContext";
import ResumeAddNew from "./ResumeAddNew";
import ResumeListItem from "./ResumeListItem";


export default function ResumeList( { title, resumes, user, children, refresh } ) {
    const { isDarkMode } = useDarkMode();

    return (
        <div>
            <ResumeAddNew user={ user }/>
            <div
                className="shadow-4 rounded-5 mt-2 table-container"
                style={ { overflowX: "auto" } }
            >
                <h2
                    className={ `text-center py-2 ${ isDarkMode ? "text-white" : ""
                    }` }
                >
                    { title }
                </h2>
                { children }
                <MDBTable>
                    <MDBTableHead className={ `${ isDarkMode ? "bg-dark-mode" : "" }` }>
                        <tr style={ { color: "#09B4BF" } }>
                            <th>
                    <span title="Ceci est le titre d'un CV">
                        Nom du CV{' '}
                        <i className="fas fa-info-circle ms-1"></i>
                    </span>
                            </th>
                            <th>Anonyme</th>
                            <th>Mot clé</th>
                            <th>Langue</th>
                            <th>Date de création</th>
                            <th>Date de modification</th>
                            <th>Statut</th>
                            <th className="text-center">Actions</th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody style={ { verticalAlign: "middle" } }>
                        { resumes.map( ( resume, index ) => (
                            <ResumeListItem
                                resume={ resume }
                                index={ index }
                                user={ user }
                                key={ resume.id }
                                /* add for refresh */
                                refresh= {refresh}
                            />
                        ) ) }
                    </MDBTableBody>
                </MDBTable>
            </div>
        </div>
    );
}

ResumeList.propTypes = {
    resumes: PropTypes.arrayOf( PropTypes.object ).isRequired,
    user: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
};
